import { render, staticRenderFns } from "./GoArtFullLoading.vue?vue&type=template&id=351b11be&scoped=true"
import script from "./GoArtFullLoading.vue?vue&type=script&lang=js"
export * from "./GoArtFullLoading.vue?vue&type=script&lang=js"
import style0 from "./GoArtFullLoading.vue?vue&type=style&index=0&id=351b11be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351b11be",
  null
  
)

export default component.exports